import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: "de",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: {
          description: {
            part1: "Fy Dapp verse",
            part2:
              "Committed to creating a new generation of Defi open encryption ecosystem",
            part3: "Who are we",
            part4:
              "A new generation of Defi open encryption ecosystem jointly created by a group of geeks pursing extream fredom and web3 community",
            part5: " The world of Fy-Metaverse",
            part6:
              "Everone has their own virtual image [2025 plan], looking for another self in the world of metaverse",
            newformtittle: " New forms of empowerment to address",
            part7:
              "  Technical problems can be solved through technical means, while the  problems of liquidity and the number of players need new forms ofempowerment to solve. ",
            part8:
              " Judging from the current gameplay and form of blockchain games,   Metaverse is a very suitable concept for empowering GameFi. And many chain games have also begun to move closer to the Metaverse.",
            advantagetitle: "Advantage ",
            part9: "FY Dapp 2.0      ",
            part10: "Support more public chains and tokens",
            part11:
              "More ecosystems will be added in the future to promote sustainable development   ",
            part12: "Partner",
          },
          card: {
            title1: "Interoperability",
            des1: "Only an efficient NFT market is needed to achieve it. Different characters can play other game worlds. Metaverse supports interoperability between NFTs and games.",
            title2: "Fluidity",
            des2: "In the Metaverse, after achieving interoperability, we will look at liquidity from a holistic perspective. By using the original NFT assets, we can easily participate in brand new games.",
            title3: "Variety of game forms",
            des3: "Web3.0 is an open world, and the vastness of the metaverse can fully support game developers to build various games on it to provide players with a rich gaming experience.",
          },
          card2: {
            head1: "Safety",
            des1: "Multi-signatures and BOR tunnels provide double assurance of assets.",
            head2: "Fast",
            des2: "Tokens can be minted/redeemed in minutes.            ",
            head3: "Protocol",
            des3: "ProtocolUser-friendly, anyone can freely use the FY DAO protocol.",
            head4: "No threshold    ",
            des4: "Non-ERC20 tokens can be easily converted into Tokens with one click. ",
            head5: "Decentralized",
            des5: "FY is deployed on Binance chain and operates in a fully decentralized manner.     ",
            head6: "DAO governance            ",
            des6: "Community members are the real controllers of FY.            ",
          },

          button: {
            btn1: " Download the white paper",
          },
          footer: {
            link1: "Home",
            link2: "White paper",
            link3: "Team",
            link4: "Staking",
            link5: "Farming",
          },
          whitepaper: {
            title1: "Defi sage white paper",
            des1: "The ultimate goal of the Defi Sage network is to revolutionize the data verification and storage process by leveraging decentralized storage providers without the need for trust.",
            part1: "business logic            ",
            part2:
              "The ultimate goal of the FY Metaverse network is to revolutionize the data verification and storage process by leveraging decentralized storage providers without the need for trust. Uploaders collect data from various sources and store them on decentralized providers. Afterwards, validators on the network validate the data by submitting it to the storage pool. Data consumers can then leverage the verified data to build decentralized applications without trusting FY Metaverse or any intermediaries.            ",
            part3:
              "Network nodes are responsible for validating and archiving data sources assigned to specific storage pools. Protocol nodes retrieve data from sources and submit it to storage pools for validation by other participants. Every participant has the right to vote on the accuracy of the data. Depending on the outcome of the voting process, data is either archived or discarded, and uploaders of data are rewarded for their contribution to the network.",
            part4: "FY Blockchain Lab            ",
            part5:
              "The FY blockchain laboratory is based on the technology of the Institute of Network Behavior of the University of Hong Kong Established in conjunction with more than ten well-known global blockchain companies, it is oriented towards blockchain innovative applications and product development, and is mainly composed of experts from the Artificial Intelligence Research Institute of the University of Hong Kong. Research on security, digital renminbi and other fields",
            part6:
              "Defi University is affiliated with Defi International Capital (Singapore). It is an open decentralized financial technology education brand. The members of its brand creation team are all experienced practitioners. Good at researching Defi, blockchain games, metaverse application investment, research, and teaching, takes the popularization of Defi knowledge as the value, is driven by performance and profit-driven, advocates the investment philosophy of pursuing long-term growth, has a complete Defi knowledge module system and strict risk management Management ability and leading international vision.",
          },
          gamefi: {
            head1: "Create a new era of Web3 game e-commerce           ",
            part1: "FY-Metaverse Zero Innovation",
            part2:
              "The characters, skins, props, equipment, materials, medicines, etc. in the game are all NFTized, focusing on the game experience, the game assets are on the chain, and can be circulated to generate value. The built-in game mall uses the virtual + physical method in the NFT synthesis process to open up industrial items Channels, creating a new era of Web3 game e-commerce",
          },
          Staking: {
            head1: "Staking",
            des: "Calculate your Defi Sage depending on the amount of staked tokens and ",
            des2: "You have no staking history yet",
            des3: "Your Statistics",
          },
          Farming: {
            head1: "Staking",
            des: "Farm Defi Sage depending on the amount of staked tokens and your lock time.",
            des1: "Lock Token For months,",
            des2: "You have no farming history yet",
            des3: "Your Statistics",
          },
          StakingUi: {
            head1: "Personal invitation Link			",
            head2: "Personal computing power",
            head3: "balance",
            head4: "Current Yield",
            head5: "Team Information",
            head6: "Level 1 computing power",
            lhead1: "Level",
            lhead2: "computing power",

            head7: "Income",
            head8: "Claimable Mining income",
            head9: "Node income",
            head10: "Prize Pool income			",
            head11: "Cumulative income			",
            head12: "Mining income",
            head13: "Actual Computing Power",
            phead1: "Prize Pool",
            phead2: "Prize Pool Amount",
            phead3: "13 days, 2 hours, 41 minutes and 55 seconds			",
            phead4: "Winners",
            phead5: "wallect address",
            phead6: "bounus amount",
            phead7: "Refferrer Address           ",
            phead8: "Amount",
            phead9: "stake",
            phead10: "Connect Wallect",
            phead11: "Mining",
            phead12: "Connect Your Wallet",
            phead13: "Pledge",
            phead14: "Release",
            phead15: "Withdraw proceed",
            phead16: "Recommended Node",
            phead17: " Amount",
          },
          FarmingUi: {
            head1: "Pledge",
            head2: "Flexible Access	",
            head3: "Income Withdrawal ",
            head5: "days",
            head6: "LP Token Staking FYM/BNB  ",
            head7: "Flexible",
            head8: "month",
            head9: "locked until",
            head10: "Your Wallect Balance     ",
            head11: "Claim Reward",
            head12: "Total Staked ",
            head13: "AMOUNT",
            head14: "WITHDRAW TIME",
            head15: "HARVEST",
            head16: "WITHDRAW",
            head17:
              "    If you encounter any problem when using the portal or account,please     send us an email in time",
            head18: "Start Time",
            head19: "Claimable Reward",
          },
          stakingfooter: {
            head1: "Partner",
            head2:
              "If you encounter any problem when using the portal or account,please send us an email in time     ",
            head3: "we respect your privacy.",
            head4: "Enter computing power",
          },
        },
      },
      de: {
        translation: {
          Farming: {
            head1: "质押",
            des: "Farm Defi Saga 取决于质押的代币数量和您的锁定时间代币和你的锁定时间",
            des1: "锁定令牌几个月",
            des2: "您还没有农业历史",
            des3: "您的统计数据",
          },
          Staking: {
            head1: "质押",
            des: "根据质押的代币数量和您的锁定时间计算您的 Defi Sage.",
            des2: "您还没有质押历史",
            des3: "您的统计数据",
          },
          description: {
            part1: "风益元宇宙",
            part2: "致力于打造新一代Defi开放加密生态",
            part3: "我们是谁",
            part4:
              "一群追求极度自由的极客与Web3社区共同创造的新一代Defi开放加密生态",
            part5: "Defi Sage 的世界",
            part6:
              "每个人都有自己的虚拟形象【2025计划】，在元宇宙的世界寻找另一个自己",
            newformtittle: "新形式的赋能来解决",
            part7:
              "技术的问题可以通过技术手段解决，而流动性和玩家数量的问题则需要新形式的赋能来解决。          ",
            part8:
              "以目前链游的玩法和形式来看，元宇宙是一个非常适合用来赋能 GameFi 的概念。而且很多链游也已经开始向元宇宙靠拢。",
            advantagetitle: "优势 ",
            part9: "FY Metaverse 2.0",
            part10: "支持更多公链和代币",
            part11: "未来将加入更多生态系统，促进可持续发展",
            part12: "合作伙伴",
          },
          card: {
            title1: "互操作性",
            des1: "只需要一个高效的NFT市场便能够实现。不同的角色可以游玩其他游戏世界。元宇宙支持了 NFT 和游戏之间的互操作性。",
            title2: "流动性",
            des2: "元宇宙中，在实现互操作性后，我们将以整体的角度看待流动性。通过使用原有的 NFT 资产，我们便可以轻松参与到全新的游戏中去。",
            title3: "游戏形式的丰富",
            des3: "Web3.0 是一个开放的世界，而元宇宙的广阔完全可以支撑游戏开发者们在其上搭建各种各样的游戏，以为玩家们提供丰富的游戏体验。",
          },
          card2: {
            head1: "安全",
            des1: "多重签名和 BOR 隧道提供了资产的双重保障。",
            head2: "快速",
            des2: "令牌可以在几分钟内铸造/赎回。",
            head3: "协议",
            des3: "用户友好，任何人都可以自由使用 FY DAO 协议。",
            head4: "无门槛无门槛",
            des4: "非ERC20代币一键轻松转换为Token。",
            head5: "去中心化",
            des5: "FY部署在 Binance chain 上，并以完全去中心化的方式运行。",
            head6: "DAO 治理",
            des6: "社区成员才是 FY 的真正掌控者。",
          },
          button: {
            btn1: "下载白皮书",
          },
          footer: {
            link1: "主页",
            link2: "白皮书",
            link3: "团队",
            link4: "质押",
            link5: "农业",
          },
          whitepaper: {
            title1: "风益元宇宙白皮书",
            des1: "FY Metaverse网络的最终目标是通过在不需要信任的情况下利用去中心化存储提供商来彻底改变数据验证和存储过程。",
            part1: " 商业逻辑            ",
            part2:
              "FY Metaverse网络的最终目标是通过在不需要信任的情况下利用去中心化存储提供商来彻底改变数据验证和存储过程。 上传者从各种来源收集数据并将它们存储在去中心化的提供商上。 之后，网络上的验证器通过将数据提交到存储池来验证数据。 然后，数据消费者可以利用经过验证的数据来构建去中心化应用程序，而无需信任 FY Metaverse 或任何中介机构。",
            part3:
              "网络节点负责验证和归档分配给特定存储池的数据源。 协议节点从源中检索数据并将其提交给存储池以供其他参与者验证。 每个参与者都有权对数据的准确性进行投票。 根据投票过程的结果，数据要么被存档要么被丢弃，数据的上传者因其对网络的贡献而获得奖励。",
            part4: "FY区块链实验室",
            part5:
              "FY区块链实验室是依托香港大学网络行为研究所技术  联合十余家全球区块链知名企业成立的，以区块链创新应用及产品研发为导向，由香港大学人工智能研究院专家为主构建成立技术指导委员会在区块链基础设施、区块链安全、数字人民币等领域展开研究",
            part6:
              "Defi 大学隶属于Defi国际资本（新加坡），是专注开放式去中心化金融科技教育品牌，其品牌创世团队成员均是资深从业者。擅长研究Defi、链游、元宇宙应用投资、研究、教学，以普及Defi知识为价值观，以业绩创盈驱动为导向，主张追求长期增长的投资理念，具备完善的Defi知识模块系统与严格的风险管理能力和领先的国际视野。",
          },
          gamefi: {
            head1: "开创Web3游戏电商新时代",
            part1: "FY-Metaverse零创生态            ",
            part2:
              "游戏内人物、皮肤、道具、装备、材料、药品等均NFT化，注重游戏体验，游戏资产上链，可流通产生价值，内置游戏商城，NFT合成过程中使用虚拟+实物的方式，打通实业物品渠道，开创Web3游戏电商新时代",
          },
          StakingUi: {
            head1: "个人邀请链接",
            head2: "个人计算能力",
            head3: "平衡",
            head4: "当前收益率",
            head5: "团队信息",
            head6: "1级算力",
            head7: "收入",
            head8: "可申請的採礦收入",
            head9: "节点收益",
            head10: "奖池收入",
            head11: "综合收入",
            head12: "挖礦收益",
            head13: "实际计算能力",
            phead1: "奖池",
            phead2: "奖池金额",
            phead3: "13天2小时41分55秒",
            phead4: "获奖者",
            phead5: "钱包地址",
            phead6: "奖金金额",
            phead7: "推荐人地址 ",
            phead8: "数量",
            phead9: "确定",
            phead10: "连接钱包",
            phead11: "质押",
            phead12: "连接你的钱包",
            phead13: "质押 ",
            phead14: "解押",
            phead15: "提取收益",
            phead16: "推荐节点          ",
            phead17: "数量",
            lhead1: "等级",
            lhead2: " 计算能力",
          },
          FarmingUi: {
            head1: "保证",
            head2: "灵活的访问		",
            head3: "收入退出 ",
            head5: "天",
            head6: "LP 代币质押 FYM/BNB ",
            head7: " 灵活的",
            head8: "月",
            head9: "锁定直到",
            head10: "您的钱包余额    ",
            head11: " 领取奖励",
            head12: "总赌注 ",
            head13: " 数量",
            head14: "提款时间",
            head15: "收成",
            head16: " 提取",
            head18: "开始时间",
            head19: "可领取奖赏",
          },
          stakingfooter: {
            head1: "伙伴",
            head2:
              "如果您在使用门户或账户时遇到任何问题，请及时给我们发送邮件     ",
            head3: "我们尊重您的隐私.",
            head4: "Enter computing power",
          },
        },
      },
    },
  });

export default i18n;
